import React from 'react';
import { useSelector } from 'react-redux';

import { StatsSection } from '../common/stats-section';
import {
    StatsLeadersPositionsFilters,
    StatsLeadersTeamsFilters
} from './components/filters';
import {
    Heading,
    BenchmarkingSwitch,
    DataTypeToggle
} from './components/header';
import {
    CategoryNavItem,
    SeasonNavItem,
    RoundNavItem
} from './components/nav-items';
import { StatsLeadersTable } from './components/table';
import {
    BenchmarkingExplainer,
    BenchmarkingLegend
} from '../../../../../../common/react/components/benchmarking';
import {
    statsLeadersBenchmarkingSelector,
    statsLeadersNavSelector
} from '../../../../store/js/modules/statspro/stats-leaders/selectors';
import { useCompetitionNavigationOptions } from '../../../../../../common/react/hooks/use-competition-navigation-options';
import { useStatsLeadersNavSync } from './hooks/use-stats-leaders-nav-sync';

/**
 * @returns {JSX.Element} Component.
 */
export const StatsLeaders = () => {
    const benchmarking = useSelector(statsLeadersBenchmarkingSelector);
    const nav = useSelector(statsLeadersNavSelector);
    const options = useCompetitionNavigationOptions(nav);
    useStatsLeadersNavSync(options);

    return (
        <StatsSection.Main>
            <StatsSection.Nav>
                <StatsSection.NavItems>
                    <CategoryNavItem />
                    <SeasonNavItem />
                    <RoundNavItem />
                </StatsSection.NavItems>
                <StatsSection.NavFilterItems>
                    <StatsLeadersPositionsFilters />
                    <StatsLeadersTeamsFilters />
                </StatsSection.NavFilterItems>
            </StatsSection.Nav>
            <StatsSection.Content>
                <StatsSection.ContentHeader>
                    <StatsSection.ContentHeaderHeading>
                        <Heading />
                    </StatsSection.ContentHeaderHeading>
                    <StatsSection.ContentHeaderOptions>
                        <BenchmarkingSwitch />
                        <DataTypeToggle />
                    </StatsSection.ContentHeaderOptions>
                    <StatsSection.ContentHeaderBelow>
                        {benchmarking?.isActive && <BenchmarkingLegend />}
                        {benchmarking?.isActive && <BenchmarkingExplainer />}
                    </StatsSection.ContentHeaderBelow>
                </StatsSection.ContentHeader>
                <StatsSection.ContentBody>
                    <StatsLeadersTable />
                </StatsSection.ContentBody>
            </StatsSection.Content>
        </StatsSection.Main>
    );
};
